module.exports = __webpack_public_path__ + "img/s_greywhiteD-logo.7dd059e.png";